import { render } from "./MotorPage.vue?vue&type=template&id=bf346ffa&scoped=true"
import script from "./MotorPage.vue?vue&type=script&lang=js"
export * from "./MotorPage.vue?vue&type=script&lang=js"

import "./MotorPage.vue?vue&type=style&index=0&id=bf346ffa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf346ffa"],['__file',"src/views/ProductManage/ModelManagement/components/MotorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf346ffa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf346ffa', __exports__)) {
    api.reload('bf346ffa', __exports__)
  }
  
  module.hot.accept("./MotorPage.vue?vue&type=template&id=bf346ffa&scoped=true", () => {
    api.rerender('bf346ffa', render)
  })

}


export default __exports__